import { useMutation } from "@tanstack/react-query";

import { errorToast } from "@/shared/ui";
import { submitBMIWithCategories } from "../api";

export const useSubmitBMIWithCategories = () => {
  return useMutation({
    mutationFn: submitBMIWithCategories,
    onError: errorToast,
  });
};
